module.exports = __webpack_public_path__ + "static/img/noData.136b7b2b.png";